import { FaPhone } from 'react-icons/fa6';
import { MdArrowForwardIos } from 'react-icons/md';

export default function PhoneButton({
  number,
  theme = 'yellow',
}: {
  number?: string;
  theme?: 'yellow' | 'green';
}) {
  if (!number) {
    number = process.env.NEXT_PUBLIC_PHONE;
  }
  if (!number) {
    return null;
  }
  const classes =
    theme === 'yellow'
      ? 'border-black bg-brand text-black'
      : theme === 'green'
        ? 'border-accent bg-accent text-white'
        : '';
  return (
    <a
      href={`tel:${number.replaceAll(' ', '')}`}
      className={`flex items-center justify-between gap-2 border-2 p-2 px-4 pr-2 font-bold hover:bg-black hover:text-white focus:bg-black focus:text-white ${classes}`}
    >
      <span className='flex items-center gap-2'>
        <FaPhone /> {number}
      </span>
      <span>
        <MdArrowForwardIos />
      </span>
    </a>
  );
}
